import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Package,
  Puzzle,
  BarChart3,
  CodeXml,
  Settings,
  UserCircle,
  Upload,
  CreditCard,
} from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/products", label: "Produkte", icon: Package },
  { to: "/import", label: "Import", icon: Upload },
  { to: "/quizzes", label: "Quizzes", icon: Puzzle },
  { to: "/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/embed", label: "Einbettung", icon: CodeXml },
  { to: "/settings", label: "Einstellungen", icon: Settings },
  { to: "/billing", label: "Abonnement", icon: CreditCard },
  { to: "/account", label: "Konto", icon: UserCircle },
];

export function Sidebar() {
  return (
    <div className="flex h-full flex-col">
      <div className="px-4 py-5">
        <h2 className="text-lg font-semibold">QuizNudge</h2>
        <p className="text-xs text-muted-foreground">Admin-Dashboard</p>
      </div>
      <Separator />
      <nav className="flex-1 space-y-1 px-2 py-3">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                isActive
                  ? "bg-accent text-accent-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
              )
            }
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
